export type LegacyMedicationStatement = {
  name: string
  frequency: string
  intake: string
}

export const NO_MEDICATION_SENTINEL_NAME = 'Geen thuismedicatie'

export const NO_MEDICATION_SENTINEL: LegacyMedicationStatement = {
  name: NO_MEDICATION_SENTINEL_NAME,
  intake: '',
  frequency: '',
}

// Synops may still return the legacy string; normalise + match both variants.
const NO_MEDICATION_NAMES = new Set(
  ['Geen thuismedicatie', 'Ik neem geen thuismedicatie'].map((n) => n.toLowerCase().trim()),
)

const isNoMedicationName = (name: string) => NO_MEDICATION_NAMES.has(name.toLowerCase().trim())

export const isNoMedicationSentinel = (meds: LegacyMedicationStatement[]) =>
  meds.length === 1 && isNoMedicationName(meds[0].name)

export const isNoMedicationEntry = (med: LegacyMedicationStatement) => isNoMedicationName(med.name)

export const filterOutNoMedicationSentinel = (meds: LegacyMedicationStatement[]) =>
  meds.filter((med) => !isNoMedicationName(med.name))
